export const SHOP_CONFIG_PENDING = 'SHOP_CONFIG_PENDING';
export const SHOP_CONFIG_SUCCESS = 'SHOP_CONFIG_SUCCESS';
export const SHOP_CONFIG_ERROR = 'SHOP_CONFIG_ERROR';
